import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-friendy',
    templateUrl: 'hc-friendy.html',
    providers: []
})
export class HcFriendy {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    constructor(public element: ElementRef) {

    }

    ngAfterViewInit() {

        //console.log(this.hpage);
        //let ant = this.blocked.Content;
        //this.blocked = this.hpage.rootdata.Hotspots[0].Branded.BrandedBody.Hspot.Array.find(item => (item.Content == this.hpage.THotpageContent.hcFriendy));
        //this.sub = (ant == this.blocked.Content);
        //console.log(this.blocked, xxx);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-friendy/hc-friendy.ts